module.exports = __webpack_public_path__ + "static/media/error-rebranded.2f734a27.svg";